document.addEventListener('turbolinks:load', () => {
    const phoneInput = document.getElementById('provider_profile_user_attributes_phone') ||
        document.getElementById('user_phone');
    const form = document.querySelector('form[id^="edit_provider_profile_"]') ||
        document.querySelector('form[action*="sign_up"], form[action*="registration"]') ||
        phoneInput?.closest('form');

    const locale = document.documentElement.lang || 'en';

    if (phoneInput && form) {
        // Initial formatting on page load
        formatPhoneNumber(phoneInput);

        // Re-format as the user types
        phoneInput.addEventListener('input', (e) => formatPhoneNumber(e.target));

        // Validate & clean up before submission
        form.addEventListener('submit', (e) => {
            const { isValid, cleanedDigits, errorMessage } = validatePhoneNumber(
                phoneInput.value,
                locale
            );

            if (!isValid) {
                e.preventDefault();
                showPhoneError(phoneInput, errorMessage);
                phoneInput.focus();
            } else {
                clearPhoneError(phoneInput);
                phoneInput.value = formatPhoneDisplay(cleanedDigits);
            }
        });
    }

    // If there's a verification code field, focus it immediately
    const verificationCodeInput = document.getElementById('verification_code_field');
    if (verificationCodeInput) {
        verificationCodeInput.focus();
    }

    setupCountdown();
    setupVerificationFormHandlers();
});


// Translation object for phone validation messages
const phoneValidationMessages = {
    en: {
        empty: "Please enter a phone number",
        invalid_area_code: "Area codes cannot start with 1",
        incomplete: "Please enter a complete 10-digit phone number",
        too_long: "Phone number is too long. Please enter a 10-digit US phone number",
        invalid: "Please enter a valid 10-digit US phone number"
    },
    es: {
        empty: "Ingresa un número de teléfono.",
        invalid_area_code: "El código de área no puede empezar con 1.",
        incomplete: "Faltan dígitos. Debe tener 10 números",
        too_long: "Demasiado largo. Usa un número de 10 dígitos",
        invalid: "Ingresa un número válido de EE.UU. con 10 dígitos."
    }
};

function getPhoneValidationMessage(key, locale = 'en') {
    const messages = phoneValidationMessages[locale] || phoneValidationMessages['en'];
    return messages[key];
}

function validatePhoneNumber(phoneValue, locale = 'en') {
    const allDigits = phoneValue.replace(/\D/g, '');

    if (allDigits.length === 0) {
        return { isValid: false, errorMessage: getPhoneValidationMessage('empty', locale) };
    }

    // Handle leading '1'
    if (allDigits.length === 11 && allDigits.startsWith('1')) {
        const phoneDigits = allDigits.slice(1);
        if (phoneDigits.startsWith('1')) {
            return {
                isValid: false,
                errorMessage: getPhoneValidationMessage('invalid_area_code', locale)
            };
        }
        return { isValid: true, cleanedDigits: phoneDigits };
    }

    if (allDigits.length === 10) {
        if (allDigits.startsWith('1')) {
            return {
                isValid: false,
                errorMessage: getPhoneValidationMessage('invalid_area_code', locale)
            };
        }
        return { isValid: true, cleanedDigits: allDigits };
    }

    if (allDigits.length < 10) {
        return { isValid: false, errorMessage: getPhoneValidationMessage('incomplete', locale) };
    }

    if (allDigits.length > 11) {
        return { isValid: false, errorMessage: getPhoneValidationMessage('too_long', locale) };
    }

    return { isValid: false, errorMessage: getPhoneValidationMessage('invalid', locale) };
}

function formatPhoneNumber(input) {
    const digits = input.value.replace(/\D/g, '');
    if (digits.length === 11 && digits.startsWith('1')) {
        input.value = formatPhoneDisplay(digits.slice(1), true);
    } else {
        input.value = formatPhoneDisplay(digits);
    }
}

function formatPhoneDisplay(digits, showCountryCode = false) {
    let formatted = '';

    if (showCountryCode && digits.length >= 3) {
        formatted = '+1 ';
    }

    if (digits.length > 0) {
        formatted += '(' + digits.slice(0, 3);
        if (digits.length > 3) {
            formatted += ') ' + digits.slice(3, 6);
            if (digits.length > 6) {
                formatted += '-' + digits.slice(6, 10);
            }
        }
    }

    return formatted;
}

function showPhoneError(phoneInput, message) {
    clearPhoneError(phoneInput);
    const errorDiv = document.createElement('div');
    errorDiv.id = 'phone-error-message';
    errorDiv.className = 'text-danger mt-1';
    errorDiv.textContent = message;
    phoneInput.parentNode.appendChild(errorDiv);
    phoneInput.classList.add('is-invalid');
}

function clearPhoneError(phoneInput) {
    const existingError = document.getElementById('phone-error-message');
    if (existingError) {
        existingError.remove();
    }
    phoneInput.classList.remove('is-invalid');
}

function setupVerificationFormHandlers() {
    document
        .querySelectorAll('[data-action="verify"], [data-action="proceed_without"], [data-action="resend"], [data-action="cancel"]')
        .forEach((button) => {
            button.addEventListener('click', () => {
                const actionField = document.getElementById('verification_action_field');
                const codeField = document.getElementById('verification_code_field');
                if (!actionField) return;

                actionField.value = button.getAttribute('data-action');
                if (codeField) {
                    if (actionField.value === 'verify') {
                        codeField.setAttribute('required', 'required');
                    } else {
                        codeField.removeAttribute('required');
                    }
                }

                const form = document.getElementById('phone_verification_form');
                if (form) form.submit();
            });
        });
}

function setupCountdown() {
    const countdownEl = document.getElementById('countdown');
    const expirationField = document.getElementById('expiration_time_field');
    if (!countdownEl || !expirationField) return;

    const expirationTime = new Date(expirationField.value);

    function update() {
        const now = new Date();
        const diffMs = expirationTime - now;

        if (diffMs <= 0) {
            countdownEl.textContent =
                document.documentElement.lang === 'es' ? 'ha expirado' : 'expired';
            return;
        }

        const minutes = Math.floor(diffMs / 60000);
        const seconds = Math.floor((diffMs % 60000) / 1000);
        const unitMin = minutes === 1 ? (document.documentElement.lang === 'es' ? 'minuto' : 'minute') : (document.documentElement.lang === 'es' ? 'minutos' : 'minutes');
        const unitSec = document.documentElement.lang === 'es' ? 'segundos' : 'seconds';

        countdownEl.textContent = `${minutes} ${unitMin} ${seconds} ${unitSec}`;
    }

    update();
    setInterval(update, 1000);
}

window.submitForm = setupVerificationFormHandlers;